import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';

export const leaveConversation = async (conversation_sid: string | undefined): Promise<IGMConversation> => {
  const { data } = await client.patch(`/conversations/${conversation_sid}/leave`, {});

  return data;
};
